import React from 'react'
import PropTypes from 'prop-types'
import Collapsible from 'react-collapsible'

import '../../../resources/web/styles/less/components/detail-accordion.less'

/**
 * DetailAccordion – collapsible helper panel for long-form explanations.
 *
 * Usage:
 *   <DetailAccordion trigger="Learn more about fees">
 *     <p>Long text, screenshots, etc.</p>
 *   </DetailAccordion>
 *
 * With FieldHelpGroup:
 *   <FieldHelpGroup details={<p>…</p>} />
 */
const DetailAccordion = ({
  trigger = 'Learn more',
  children,
  initiallyOpen = false,
  className = '',
}) => {
  return (
    <Collapsible
      open={initiallyOpen}
      transitionTime={150}
      overflowWhenOpen="hidden"
      trigger={
        <span className="detail-accordion-trigger">
          {trigger} <i className="fa fa-chevron-down" aria-hidden="true" />
        </span>
      }
      triggerWhenOpen={
        <span className="detail-accordion-trigger">
          {trigger} <i className="fa fa-chevron-up" aria-hidden="true" />
        </span>
      }
      className={`detail-accordion ${className}`}
      openedClassName={`detail-accordion opened ${className}`}
      aria-expanded={initiallyOpen}
    >
      <div className="detail-accordion-body">{children}</div>
    </Collapsible>
  )
}

DetailAccordion.propTypes = {
  trigger: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.node.isRequired,
  initiallyOpen: PropTypes.bool,
  className: PropTypes.string,
}

export default DetailAccordion 
